var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar container-fluid"},[_c('div',{staticClass:"row"},[_c('Menu',{attrs:{"title":"Calendar"}}),_c('div',{staticClass:"col-12 p-0"},[_c('Calendar',{attrs:{"id":"calendar_view"}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }